import React, { VFC, useMemo } from 'react';
import VaultsPage, { VaultsPageProps } from './VaultsPage';
import { useUserContext } from '../../contexts/UserContext';

const filterVaults = (allVaults: any[], account: string) => {
  const isAdmin = account.toLowerCase() === '0xb29cd9c87a624b940335d6d5e1d4aadf7d95beec';

  return allVaults
    .filter((vault: any) => {
      const { amountUserStaked } = vault;

      const noAmountStaked = !amountUserStaked || amountUserStaked;
      const deprecated = vault.deprecated || (vault.rewardsPerDay === 0 && !isAdmin);

      return !(
        vault.hidden ||
        (noAmountStaked && (deprecated || vault.hiddenForNonStaked) && !vault.forceShow)
      );
    })
    .sort((a, b) => b.valueTotalStaked - a.valueTotalStaked);
};

type VaultsPageContainerProps = Omit<VaultsPageProps, 'vaultsToDisplay' | 'myVaults'>;

const VaultsPageContainer: VFC<VaultsPageContainerProps> = (props) => {
  const { account } = useUserContext();
  const { vaults } = props;

  const vaultsToDisplay = useMemo(() => filterVaults(vaults, account), [account, vaults]);
  const myVaults = useMemo(
    () => vaultsToDisplay.filter((vault) => vault.valueUserStaked),
    [vaultsToDisplay],
  );

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <VaultsPage vaultsToDisplay={vaultsToDisplay} myVaults={myVaults} {...props} />;
};

export default VaultsPageContainer;
